import {
  GET_REPORTS,
  GET_REPORTS_FAIL,
  GET_REPORTS_SUCCESS,
  GET_AUTH_USER,
  GET_AUTH_USER_FAIL,
  GET_AUTH_USER_SUCCESS,
  ADD_NEW_REPORT,
  ADD_REPORT_SUCCESS,
  ADD_REPORT_FAIL,
  UPDATE_REPORT,
  UPDATE_REPORT_SUCCESS,
  UPDATE_REPORT_FAIL,
  DELETE_REPORT,
  DELETE_REPORT_SUCCESS,
  DELETE_REPORT_FAIL,
  GET_REPORT_DETAIL,
} from "./actionTypes"

export const getReports = page => ({
  type: GET_REPORTS,
  payload: page,

})

export const getReportsSuccess = reports => ({
  type: GET_REPORTS_SUCCESS,
  payload: reports,
})

export const getReportsFail = error => ({
  type: GET_REPORTS_FAIL,
  payload: error,
})

export const getAuthUsers = auth => ({
  type: GET_AUTH_USER,
  payload: auth,

})

export const getAuthUsersSuccess = auth => ({
  type: GET_AUTH_USER_SUCCESS,
  payload: auth,
})

export const getAuthUsersFail = error => ({
  type: GET_AUTH_USER_FAIL,
  payload: error,
})

export const addNewReport = quote => ({
  type: ADD_NEW_REPORT,
  payload: quote,
})

export const addReportSuccess = quote => ({
  type: ADD_REPORT_SUCCESS,
  payload: quote,
})

export const addReportFail = error => ({
  type: ADD_REPORT_FAIL,
  payload: error,
})

export const updateReport = quote => ({
  type: UPDATE_REPORT,
  payload: quote,
})

export const updateReportSuccess = quote => ({
  type: UPDATE_REPORT_SUCCESS,
  payload: quote,
})

export const updateReportFail = error => ({
  type: UPDATE_REPORT_FAIL,
  payload: error,
})

export const deleteReport = quote => ({
  type: DELETE_REPORT,
  payload: quote,
})

export const deleteReportSuccess = quote => ({
  type: DELETE_REPORT_SUCCESS,
  payload: quote,
})

export const deleteReportFail = error => ({
  type: DELETE_REPORT_FAIL,
  payload: error,
})

export const getReportDetails = quote => ({
  type: GET_REPORT_DETAIL,
  payload: quote,
})

export const getReportDetailFail = error => ({
  type: GET_REPORT_DETAIL_FAIL,
  payload: error,
})


export const getReportDetailSuccess = quote => ({
  type: GET_REPORT_DETAIL_SUCCESS,
  payload: quote,
})


